// @flow

import React from 'react';
import { FormattedMessage } from 'react-intl';
import CpyToClip from 'react-copy-to-clipboard';
import { Input, Tooltip, InputProps } from '~/components';
// $FlowIssue
import { ReactComponent as IconCopy } from '@/icons/ic-copy.svg';

import messages from './messages';

export type CopyToClipboardProps = InputProps & {
  onCopy?: () => void,
  onOver?: () => void,
  isCopied?: boolean,
  value?: string,
};

/**
 * CopyToClipboard React-component
 * @memberof components/CopyToClipboard
 * @param {Object} props - properties
 * @param {string} [props.value] - value
 * @param {string} [props.palette = 'primary'] - current page palette
 * @example <caption>Simple usage</caption>
 * <CopyToClipboard />
 * @returns {React.Node<*>} React-component
 */
export const CopyToClipboard = ({
  onCopy,
  onOver,
  isCopied,
  value,
  ...rest
}: CopyToClipboardProps) => (
  <Input
    testid="copy-to-clipboard"
    rightIcon={
      <Tooltip
        overlay={
          <FormattedMessage {...messages[isCopied ? 'copied' : 'copy']} />
        }
      >
        <CpyToClip text={value}>
          <IconCopy onClick={onCopy} onMouseOver={onOver} />
        </CpyToClip>
      </Tooltip>
    }
    value={value}
    readOnly
    {...rest}
  />
);
